<!-- <div class="navbar-container">
  <div
    fill="clear"
    type="button"
    class="nav-button ion-activatable ripple-parent"
    [routerLink]="['/home']"
    [class.nav-selected]="isRouteActive('/home')"
    translate
  >
    <span class="material-symbols-outlined"> home </span>
    <ion-ripple-effect></ion-ripple-effect>
    homeTitle
  </div>
  @if(currentRole === 'LTC_DOCTOR' || currentRole === 'SPECIALTY_DOCTOR') {
    <div
      fill="clear"
      type="button"
      class="nav-button ion-activatable ripple-parent"
      [routerLink]="['/patients']"
      [class.nav-selected]="isRouteActive('/patients')"
      translate
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="23"
        viewBox="0 0 27 23"
        fill="none"
      >
        <path
          d="M19.6401 1.06585L21.2976 3.4138H25.0351C25.5754 3.4138 26.0101 3.87563 26.0101 4.44967C26.0101 5.02371 25.5754 5.48553 25.0351 5.48553H20.8101C20.5014 5.48553 20.2129 5.33015 20.0301 5.07119L19.0511 3.68572L17.1417 7.9975C16.9914 8.33416 16.6826 8.56291 16.3333 8.58881C15.9839 8.61471 15.6467 8.44206 15.4517 8.1313L13.7901 5.48553H8.78513C8.24482 5.48553 7.81013 5.02371 7.81013 4.44967C7.81013 3.87563 8.24482 3.4138 8.78513 3.4138H14.3101C14.6351 3.4138 14.9398 3.58645 15.1226 3.87563L16.1139 5.45532L17.9786 1.24712C18.1248 0.919099 18.4214 0.694662 18.7626 0.655817C19.1039 0.616972 19.437 0.772352 19.6401 1.06585ZM13.0101 7.55726H13.5261L14.367 8.89957C14.822 9.62467 15.6101 10.0347 16.4267 9.96996C17.2433 9.90522 17.9664 9.37865 18.3158 8.58881L18.7748 7.55726H22.1101C24.2633 7.55726 26.0101 9.41318 26.0101 11.7007V21.3688C26.0101 22.1327 25.4292 22.7499 24.7101 22.7499C23.9911 22.7499 23.4101 22.1327 23.4101 21.3688V19.9876H14.3101H13.0101H2.61013V21.3688C2.61013 22.1327 2.02919 22.7499 1.31013 22.7499C0.591069 22.7499 0.0101318 22.1327 0.0101318 21.3688V4.79496C0.0101318 4.03101 0.591069 3.4138 1.31013 3.4138C2.02919 3.4138 2.61013 4.03101 2.61013 4.79496V15.8442H11.7101V8.93841C11.7101 8.17446 12.2911 7.55726 13.0101 7.55726ZM7.16013 7.55726C8.02209 7.55726 8.84874 7.92105 9.45823 8.56859C10.0677 9.21613 10.4101 10.0944 10.4101 11.0101C10.4101 11.9259 10.0677 12.8042 9.45823 13.4517C8.84874 14.0992 8.02209 14.463 7.16013 14.463C6.29818 14.463 5.47153 14.0992 4.86203 13.4517C4.25254 12.8042 3.91013 11.9259 3.91013 11.0101C3.91013 10.0944 4.25254 9.21613 4.86203 8.56859C5.47153 7.92105 6.29818 7.55726 7.16013 7.55726Z"
          fill=""
        />
      </svg>
      <ion-ripple-effect></ion-ripple-effect>
      patientsTitle
    </div>
  }
  @if(currentRole === 'FACILITY_MANAGER') {
    <div
      fill="clear"
      type="button"
      class="nav-button ion-activatable ripple-parent"
      [routerLink]="['/patients']"
      [class.nav-selected]="isRouteActive('/patients')"
      translate
    >
      <span class="material-symbols-outlined">location_away</span>
      <ion-ripple-effect></ion-ripple-effect>
      residentsTitle
    </div>
  }
  @if(currentRole === 'PATIENT') {
    <div
      fill="clear"
      type="button"
      class="nav-button ion-activatable ripple-parent"
      [routerLink]="['/patients']"
      [class.nav-selected]="isRouteActive('/patients')"
      translate
    >
      <span class="material-symbols-outlined">location_away</span>
      <ion-ripple-effect></ion-ripple-effect>
      dependentsTitle
    </div>
  }

  <div
    fill="clear"
    type="button"
    class="nav-button ion-activatable ripple-parent isAdd"
    [routerLink]="['/submissions']"
    [class.nav-selected]="isRouteActive('/submissions')"
  >
    <span class="material-symbols-outlined"> add</span>
    <ion-ripple-effect></ion-ripple-effect>
  </div>

  <div class="nav-button ion-activatable ripple-parent navbar-spacebox"></div>

  <div
    fill="clear"
    type="button"
    class="nav-button ion-activatable ripple-parent"
    [routerLink]="['/orders']"
    [class.nav-selected]="isRouteActive('/orders')"
    translate
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="23"
      viewBox="0 0 26 23"
      fill="none"
    >
      <path
        d="M7.81014 0.649994C6.28645 0.649994 5.04764 1.8888 5.04764 3.41249V19.9875C5.04764 21.5112 6.28645 22.75 7.81014 22.75H18.8601C20.3838 22.75 21.6226 21.5112 21.6226 19.9875V7.55624H16.0976C15.3336 7.55624 14.7164 6.939 14.7164 6.17499V0.649994H7.81014ZM16.0976 0.649994V6.17499H21.6226L16.0976 0.649994ZM9.5367 9.11015H12.6445C14.0732 9.11015 15.2344 10.2713 15.2344 11.7C15.2344 12.8007 14.548 13.7373 13.5812 14.1129L15.4372 15.8524L16.8962 14.5143C17.2458 14.1906 17.794 14.2165 18.1177 14.5661C18.4414 14.9157 18.4155 15.4639 18.0659 15.7876L16.7019 17.0394L18.0702 18.3214C18.4199 18.6494 18.4371 19.1933 18.1091 19.5429C17.781 19.8925 17.2372 19.9098 16.8875 19.5818L15.4243 18.2091L13.9179 19.5904C13.5682 19.9141 13.02 19.8882 12.6963 19.5386C12.3726 19.189 12.3985 18.6408 12.7481 18.317L14.1553 17.0264L11.3582 14.4021C11.3194 14.3675 11.2892 14.3287 11.2589 14.2898H10.3957V16.1891C10.3957 16.6639 10.0072 17.0523 9.53238 17.0523C9.05758 17.0523 8.6691 16.6639 8.6691 16.1891V13.4266V9.97343C8.6691 9.49863 9.05758 9.11015 9.53238 9.11015H9.5367ZM12.6445 12.5633C13.1193 12.5633 13.5078 12.1748 13.5078 11.7C13.5078 11.2252 13.1193 10.8367 12.6445 10.8367H10.4V12.5633H12.6445Z"
        fill=""
      />
    </svg>
    <ion-ripple-effect></ion-ripple-effect>
    ordersTitle
  </div>

  <div
    fill="clear"
    type="button"
    class="nav-button ion-activatable ripple-parent"
    [routerLink]="['/documents']"
    [class.nav-selected]="isRouteActive('/documents')"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="23"
      viewBox="0 0 26 23"
      fill="none"
    >
      <path
        d="M4.00408 9.46156L0 16.9598V3.15714C0 1.41578 1.29557 0 2.88908 0H8.19324C8.96065 0 9.69646 0.330513 10.2382 0.922478L11.4344 2.22973C11.9761 2.8217 12.7119 3.15221 13.4793 3.15221L18.779 3.15714C20.3725 3.15714 21.6681 4.57292 21.6681 6.31429V7.89286H6.50042C5.47119 7.89286 4.52321 8.48975 4.00408 9.46156ZM5.24999 10.2558C5.51182 9.76741 5.98581 9.47143 6.50042 9.47143H24.5571C25.0763 9.47143 25.5503 9.77234 25.8076 10.2656C26.0649 10.759 26.0649 11.3608 25.8031 11.8492L20.7472 21.3206C20.4899 21.804 20.0159 22.1 19.5013 22.1H1.44454C0.925407 22.1 0.451418 21.7991 0.19411 21.3058C-0.0631985 20.8125 -0.0631986 20.2106 0.198624 19.7223L5.25451 10.2508L5.24999 10.2558Z"
        fill=""
      />
    </svg>
    <ion-ripple-effect></ion-ripple-effect>
    Docs
  </div>
</div> -->

@if(!isKeyboardOpen) {
<div class="navbar-container navbar-footer">
  <!-- left side -->
  <div class="navbar-side left">
    <div
      fill="clear"
      type="button"
      class="nav-button ion-activatable ripple-parent"
      [routerLink]="['/home']"
      [class.nav-selected]="isRouteActive('/home')"
      translate
    >
      <span class="material-symbols-outlined"> home </span>
      <ion-ripple-effect></ion-ripple-effect>
      homeTitle
    </div>

    @if(currentRole === 'LTC_DOCTOR' || currentRole === 'SPECIALTY_DOCTOR' ||
    currentRole === 'CAREGIVER') {
    <div
      fill="clear"
      type="button"
      class="nav-button ion-activatable ripple-parent"
      [routerLink]="['/patients']"
      [class.nav-selected]="isRouteActive('/patients')"
      translate
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="23"
        viewBox="0 0 27 23"
        fill="none"
      >
        <path
          d="M19.6401 1.06585L21.2976 3.4138H25.0351C25.5754 3.4138 26.0101 3.87563 26.0101 4.44967C26.0101 5.02371 25.5754 5.48553 25.0351 5.48553H20.8101C20.5014 5.48553 20.2129 5.33015 20.0301 5.07119L19.0511 3.68572L17.1417 7.9975C16.9914 8.33416 16.6826 8.56291 16.3333 8.58881C15.9839 8.61471 15.6467 8.44206 15.4517 8.1313L13.7901 5.48553H8.78513C8.24482 5.48553 7.81013 5.02371 7.81013 4.44967C7.81013 3.87563 8.24482 3.4138 8.78513 3.4138H14.3101C14.6351 3.4138 14.9398 3.58645 15.1226 3.87563L16.1139 5.45532L17.9786 1.24712C18.1248 0.919099 18.4214 0.694662 18.7626 0.655817C19.1039 0.616972 19.437 0.772352 19.6401 1.06585ZM13.0101 7.55726H13.5261L14.367 8.89957C14.822 9.62467 15.6101 10.0347 16.4267 9.96996C17.2433 9.90522 17.9664 9.37865 18.3158 8.58881L18.7748 7.55726H22.1101C24.2633 7.55726 26.0101 9.41318 26.0101 11.7007V21.3688C26.0101 22.1327 25.4292 22.7499 24.7101 22.7499C23.9911 22.7499 23.4101 22.1327 23.4101 21.3688V19.9876H14.3101H13.0101H2.61013V21.3688C2.61013 22.1327 2.02919 22.7499 1.31013 22.7499C0.591069 22.7499 0.0101318 22.1327 0.0101318 21.3688V4.79496C0.0101318 4.03101 0.591069 3.4138 1.31013 3.4138C2.02919 3.4138 2.61013 4.03101 2.61013 4.79496V15.8442H11.7101V8.93841C11.7101 8.17446 12.2911 7.55726 13.0101 7.55726ZM7.16013 7.55726C8.02209 7.55726 8.84874 7.92105 9.45823 8.56859C10.0677 9.21613 10.4101 10.0944 10.4101 11.0101C10.4101 11.9259 10.0677 12.8042 9.45823 13.4517C8.84874 14.0992 8.02209 14.463 7.16013 14.463C6.29818 14.463 5.47153 14.0992 4.86203 13.4517C4.25254 12.8042 3.91013 11.9259 3.91013 11.0101C3.91013 10.0944 4.25254 9.21613 4.86203 8.56859C5.47153 7.92105 6.29818 7.55726 7.16013 7.55726Z"
          fill=""
        />
      </svg>
      <ion-ripple-effect></ion-ripple-effect>
      patientsTitle
    </div>
    } @if(currentRole === 'FACILITY_MANAGER') {
    <div
      fill="clear"
      type="button"
      class="nav-button ion-activatable ripple-parent"
      [routerLink]="['/patients']"
      [class.nav-selected]="isRouteActive('/patients')"
      translate
    >
      <span class="material-symbols-outlined">location_away</span>
      <ion-ripple-effect></ion-ripple-effect>
      residentsTitle
    </div>
    } @if(currentRole === 'PATIENT') {
    <div
      fill="clear"
      type="button"
      class="nav-button ion-activatable ripple-parent"
      [routerLink]="['/patients']"
      [class.nav-selected]="isRouteActive('/patients')"
      translate
    >
      <span class="material-symbols-outlined">location_away</span>
      <ion-ripple-effect></ion-ripple-effect>
      dependentsTitle
    </div>
    }
  </div>

  <!-- Center -->
  <div class="navbar-center">
    <div
      fill="clear"
      type="button"
      class="nav-button ion-activatable ripple-parent isAdd"
      [routerLink]="['/submissions']"
      [class.nav-selected]="isRouteActive('/submissions')"
    >
      <span class="material-symbols-outlined"> add</span>
      <ion-ripple-effect></ion-ripple-effect>
    </div>
  </div>

  <!-- Right side -->
  <div class="navbar-side right">
    <div
      fill="clear"
      type="button"
      class="nav-button ion-activatable ripple-parent"
      [routerLink]="['/orders']"
      [class.nav-selected]="isRouteActive('/orders')"
      translate
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="23"
        viewBox="0 0 26 23"
        fill="none"
      >
        <path
          d="M7.81014 0.649994C6.28645 0.649994 5.04764 1.8888 5.04764 3.41249V19.9875C5.04764 21.5112 6.28645 22.75 7.81014 22.75H18.8601C20.3838 22.75 21.6226 21.5112 21.6226 19.9875V7.55624H16.0976C15.3336 7.55624 14.7164 6.939 14.7164 6.17499V0.649994H7.81014ZM16.0976 0.649994V6.17499H21.6226L16.0976 0.649994ZM9.5367 9.11015H12.6445C14.0732 9.11015 15.2344 10.2713 15.2344 11.7C15.2344 12.8007 14.548 13.7373 13.5812 14.1129L15.4372 15.8524L16.8962 14.5143C17.2458 14.1906 17.794 14.2165 18.1177 14.5661C18.4414 14.9157 18.4155 15.4639 18.0659 15.7876L16.7019 17.0394L18.0702 18.3214C18.4199 18.6494 18.4371 19.1933 18.1091 19.5429C17.781 19.8925 17.2372 19.9098 16.8875 19.5818L15.4243 18.2091L13.9179 19.5904C13.5682 19.9141 13.02 19.8882 12.6963 19.5386C12.3726 19.189 12.3985 18.6408 12.7481 18.317L14.1553 17.0264L11.3582 14.4021C11.3194 14.3675 11.2892 14.3287 11.2589 14.2898H10.3957V16.1891C10.3957 16.6639 10.0072 17.0523 9.53238 17.0523C9.05758 17.0523 8.6691 16.6639 8.6691 16.1891V13.4266V9.97343C8.6691 9.49863 9.05758 9.11015 9.53238 9.11015H9.5367ZM12.6445 12.5633C13.1193 12.5633 13.5078 12.1748 13.5078 11.7C13.5078 11.2252 13.1193 10.8367 12.6445 10.8367H10.4V12.5633H12.6445Z"
          fill=""
        />
      </svg>
      <ion-ripple-effect></ion-ripple-effect>
      ordersTitle
    </div>

    <div
      fill="clear"
      type="button"
      class="nav-button ion-activatable ripple-parent"
      [routerLink]="['/documents']"
      [class.nav-selected]="isRouteActive('/documents')"
    >
<!--      <svg-->
<!--        xmlns="http://www.w3.org/2000/svg"-->
<!--        width="26"-->
<!--        height="23"-->
<!--        viewBox="0 0 26 23"-->
<!--        fill="none"-->
<!--      >-->
<!--        <path-->
<!--          d="M4.00408 9.46156L0 16.9598V3.15714C0 1.41578 1.29557 0 2.88908 0H8.19324C8.96065 0 9.69646 0.330513 10.2382 0.922478L11.4344 2.22973C11.9761 2.8217 12.7119 3.15221 13.4793 3.15221L18.779 3.15714C20.3725 3.15714 21.6681 4.57292 21.6681 6.31429V7.89286H6.50042C5.47119 7.89286 4.52321 8.48975 4.00408 9.46156ZM5.24999 10.2558C5.51182 9.76741 5.98581 9.47143 6.50042 9.47143H24.5571C25.0763 9.47143 25.5503 9.77234 25.8076 10.2656C26.0649 10.759 26.0649 11.3608 25.8031 11.8492L20.7472 21.3206C20.4899 21.804 20.0159 22.1 19.5013 22.1H1.44454C0.925407 22.1 0.451418 21.7991 0.19411 21.3058C-0.0631985 20.8125 -0.0631986 20.2106 0.198624 19.7223L5.25451 10.2508L5.24999 10.2558Z"-->
<!--          fill=""-->
<!--        />-->
<!--      </svg>-->
      <span class="material-symbols-outlined">folder_open</span>

      <ion-ripple-effect></ion-ripple-effect>
      Docs
    </div>
  </div>
</div>
}
